<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>后台管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form  class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加用户</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="mobile" label="用户名" width="200">
      </el-table-column>
      <el-table-column sortable prop="username" label="描述" width="200">
      </el-table-column>
      <el-table-column sortable prop="email" label="邮箱" width="200">
      </el-table-column>
      <el-table-column sortable prop="status" label="状态" width="200">
        <template slot-scope="scope">
          <el-button size="mini" v-if="scope.row.status == 0" type="danger">禁用</el-button>
          <el-button size="mini" type="success" v-if="scope.row.status ==1 ">启用</el-button>
        </template>
      </el-table-column>
      <el-table-column sortable prop="role_name" label="角色" width="200">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="primary" @click="handlePwd(scope.$index, scope.row)">修改密码</el-button>
          <el-button size="mini" type="danger" @click="deleteAdmins(scope.$index, scope.row)">删除</el-button>

        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->

    <el-dialog title="修改密码" :visible.sync="passwordVisible" width="50%" @click="closePwdDialog">
      <el-form label-width="120px" :model="passwordForm"  ref="passwordForm">
        <el-form-item label="密码" prop="password">
          <el-input size="small" v-model="passwordForm.password" auto-complete="off" placeholder="8到16位数字字母组合和含!、#、$、~、@字符组合"></el-input>
        </el-form-item>
        <el-form-item label="再次输入密码" prop="password_confirm">
          <el-input size="small" v-model="passwordForm.password_confirm" auto-complete="off" placeholder="8到16位数字字母组合和含!、#、$、~、@字符组合"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closePwdDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="resetPass('editForm')">保存</el-button>
      </div>
    </el-dialog>


    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="用户名" prop="mobile">
          <el-input size="small" v-model="editForm.mobile" auto-complete="off" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="username">
          <el-input size="small" v-model="editForm.username" auto-complete="off" placeholder="请输入描述"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" v-if="!editForm.id">
          <el-input size="small" v-model="editForm.password" auto-complete="off" placeholder="请输入密码8到16位数字字母组合和含!、#、$、~、@字符组合"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password_confirm" v-if="!editForm.id">
          <el-input size="small" v-model="editForm.password_confirm" auto-complete="off" placeholder="请输入密码8到16位数字字母组合和含!、#、$、~、@字符组合"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input size="small" v-model="editForm.email" auto-complete="off" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="角色:">
        <el-select v-model="editForm.role_id" placeholder="请选择角色">
          <el-option v-for="item in roleList" :label="item.role_name" :value="item.role_id" :key="item.role_id"></el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="场地名称:">
          <el-select v-model="editForm.station_id" placeholder="请选择场地"  multiple>
            <el-option v-for="item in station_names" :label="item.station_name" :value="item.id" :key="item.station_name"></el-option>
          </el-select>
        </el-form-item>
          <el-form-item label="状态:">
          <el-select v-model="editForm.status" placeholder="请选择">
              <el-option v-for="item in status_names" :label="item.name" :value="item.val" :key="item.val"></el-option>
            </el-select>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getStationNames } from '../../api/station'
import { getAdmins,addAdmins,updateAdmins,deleteAdmins,resetPass } from '../../api/adminuser'
import { getRole} from '../../api/role'

import { deptList, deptSave, deptDelete } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import {
  pcaTextArr,
} from "element-china-area-data";
export default {
  data() {
    return {
      roleList:[],
      pcaTextArr,
      selectedOptions: [],
      station_names:[],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      passwordVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        username: '',
        password: '',
        mobile: '',
        email: '',
        role_id: '',
        status: 1,
        station_id:'',
      },
      passwordForm: {
        id: '',
        password: '',
      },
      status_names:[{name:'禁用',val:0},{name:'启用',val:1}],
      // rules表单验证
      rules: {
        username: [
          { required: true, message: '请输入用户名称', trigger: 'blur' }
        ],

      },
      formInline: {
        page: 1,
        limit: 10,
      },
      // 删除部门
      seletedata: {
        ids: '',
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getStationNames()
    this.getRole()
    this.getdata()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getStationNames(){
      getStationNames().then(res => {
        if (res.code == 0) {
            this.station_names = res.data
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },

    getRole(){
      getRole().then(res => {
          this.roleList = res.data
      })
    },
    // 获取公司列表
    getdata() {
      this.loading = true
      getAdmins(this.formInline).then(res => {
        if (res.code == 0) {
          this.loading = false
          this.listData = res.data.data
          this.pageparm.currentPage = res.data.current_page
          this.pageparm.pageSize = res.data.per_page
          this.pageparm.total = res.data.total
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      this.editForm =  {
          mobile: '',
          username: '',
          email: '',
          role_id: '',
          status: 1,
          password: '',
          password_confirm:'',
          station_id:''
        }
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.mobile = row.mobile
        this.editForm.username = row.username
        this.editForm.email = row.email
        this.editForm.role_id = row.role_id
        this.editForm.status = row.status
        this.editForm.station_id = row.station_id != null && row.station_id.length > 0? row.station_id.split(',').map(Number) :''
        this.editForm.id = row.id
      } else {
        this.title = '添加'
        this.editForm =  {
          mobile: '',
          username: '',
          email: '',
          role_id: '',
          status: 1,
          password: '',
          password_confirm:'',
          station_id:''
        }
      }
    },
    handlePwd: function(index, row) {
      this.passwordVisible = true
      this.passwordForm.id = row.id
      console.log(this.passwordForm.id)
      if (row != undefined && row != 'undefined') {
        this.passwordForm.id = row.id
      }
    },
    resetPass() {
      if(this.passwordForm.password_confirm != this.passwordForm.password){
        this.$message({
            type: 'warning',
            message: '2次密码输入不一致'
          })
          return false ;

      }
      resetPass(this.passwordForm.id,this.passwordForm)
          .then(res => {
            if (res.code == 0 ) {
              this.$message({
                type: 'success',
                message: '修改成功!'
              })
              this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'warning',
                message: res.message
              })
            }
            this.passwordVisible = false
          })
          .catch(err => {
            this.passwordVisible = false
            this.$message.error('修改失败，请稍后再试！')
          })
    },

    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.id){
            updateAdmins(this.editForm.id,this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code ==0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }else{
            addAdmins(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code ==0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '添加成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('添加失败，请稍后再试！')
            })
          }

        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteAdmins(index, row) {
      this.$confirm('此操作将删除该用户, 是否继续?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteAdmins(row.id)
            .then(res => {
              if (res.code == 0 ) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },
    closePwdDialog() {
      this.passwordVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/system/User.vue